import { Secure } from '../../../enums/secure.enum';
import { Parameters } from './parameters.model';
import { Status } from '../../../enums/status.enum';

/**
 * A class to store HTTP request options
 */
export class Options {
  /** The ID of the object */
  public id: string;

  /** An enum indicating whether then API endpoint is secure */
  public secure: Secure;

  /** The API endpoint URL */
  public url: string;

  /** Boolean indocating whether the ID should be validated */
  public validateId: boolean;

  /** The type of the object */
  public objectType: any;

  /** An object containing the query parameters */
  public parameters: Parameters;

  /** An array of errors that should be suppressed (i.e. no error dialog shown) */
  public suppressedErrors: Status[] = [];

  /**
   * Constructor
   */
  constructor() {
    this.parameters = new Parameters();
  }
}
